import React from 'react';

import { RecordContextProvider, useRecordContext } from 'react-admin';

import { get } from 'lodash';

import DiffFieldLayout from './DiffFieldLayout';
import ReferenceEntityField from '../../../customFields/ReferenceEntityField';
import EntityDisplayNameField from '../../../customFields/EntityDisplayNameField';

const ReferenceEntityDiffField = ({
  source,
  label,
}: {
  source: string;
  label: string;
}) => {
  const record = useRecordContext();

  const oldEntity = {
    id: get(record, `${source}.id.oldRawValue`),
    type: get(record, `${source}.type.oldRawValue`),
  };
  const newEntity = {
    id: get(record, `${source}.id.newRawValue`),
    type: get(record, `${source}.type.newRawValue`),
  };

  return (
    <DiffFieldLayout
      label={label}
      oldElement={(
        <RecordContextProvider value={oldEntity}>
          <ReferenceEntityField source="">
            <EntityDisplayNameField chip />
          </ReferenceEntityField>
        </RecordContextProvider>
      )}
      newElement={(
        <RecordContextProvider value={newEntity}>
          <ReferenceEntityField source="">
            <EntityDisplayNameField chip />
          </ReferenceEntityField>
        </RecordContextProvider>
      )}
    />
  );
};

export default ReferenceEntityDiffField;
